/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, Switch } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../../Components/DropZone';
import PageLayout from '../../Components/PageLayout';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as CityIcon } from "../../Assets/svg/CityIcon.svg";
// import { ReactComponent as FilterIcon } from "../../Assets/svg/FilterIcon.svg";
// import { ReactComponent as NotificationIcon } from "../../Assets/svg/NotificationIcon.svg";
// import { ReactComponent as LabelsIcon } from "../../Assets/svg/LabelsIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as MapMarkerIcon } from "../../Assets/svg/MapMarkerIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as SreachIcon } from "../../Assets/svg/SreachIcon.svg";
import { ReactComponent as DownloadIcon } from "../../Assets/svg/DownloadIcon.svg";
import { ReactComponent as PersonList } from "../../Assets/svg/PersonList.svg";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
// import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import { NumericFormat } from 'react-number-format';
// import {
//     useParams
// } from "react-router-dom";
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import ButtonNavigation from '../../Components/ButtonNavigation';
import PropItem from '../../Components/PropItem';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SettingIcon } from "../../Assets/svg/SettingIcon.svg";
import { useSearchPropStore } from '../../store/searchProperty';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
// import InfiniteScroll from "react-infinite-scroll-component";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import useForceUpdate from 'use-force-update';
import { useUserStore } from '../../store/user';
import moment from "moment-jalaali"
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../../Components/persian-mobile-datepicker-config'
import { priceItems, meterItems, dateTypes } from "../../api/ListData"
import { scrollingDiv } from '../../Components/ScrollRightToLeftDrag'
import Cookies from 'js-cookie'
import SearchByUser from '../../Components/SearchByUser';
import { CheckPermissions } from '../../Components/CheckPermissions';
import MapComponent from '../../Components/Map';
import { InView } from 'react-intersection-observer';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        className: 'tab-btn',
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};





function SearchProperty(props) {

    const { enqueueSnackbar } = useSnackbar();

    const [tabValue, setTabValue] = React.useState(0);
    const [openZoneModal, setOpenZoneModal] = React.useState(false);
    const [areasItems, setAreasItems] = React.useState([]);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [salePriceModal, setSalePriceModal] = React.useState(false);
    const [rentPriceModal, setRentPriceModal] = React.useState(false);
    const [rahnPriceModal, setRahnPriceModal] = React.useState(false);
    const [tmpRentPriceModal, setTmpRentPriceModal] = React.useState(false);
    const [tmpRahnPriceModal, setTmpRahnPriceModal] = React.useState(false);
    const [tmpSalePriceModal, setTmpSalePriceModal] = React.useState(false);
    const [selectMeterModal, setSelectMeterModal] = React.useState(false);
    const [selectSpaceModal, setSelectSpaceModal] = React.useState(false);
    const [moreModal, setMoreModal] = React.useState(false);
    const [melkTypeModal, setMelkTypeModal] = React.useState(false);
    const [showPriceItem, setShowPriceItem] = React.useState(1);
    const [showMeterItem, setShowMeterItem] = React.useState(1);
    const [melkTabValue, setMelkTabValue] = React.useState(0);
    const [openSelectTypeModal, setOpenSelectTypeModal] = React.useState(false);
    const [showYearItem, setShowYearItem] = React.useState(false);
    const [selectYearModal, setSelectYearModal] = React.useState(false);
    const [nowDate, setNowDate] = React.useState("");
    const [yearDates, setYearDates] = React.useState([]);
    const [openSanadModal, setOpenSanadModal] = React.useState(false);
    const [openDateTypeModal, setOpenDateTypeModal] = React.useState(false);
    const [openSearchTypeModal, setOpenSearchTypeModal] = React.useState(false);
    const [openUserTypeModal, setOpenUserTypeModal] = React.useState(false);
    const [openMapModal, setOpenMapModal] = React.useState(false);
    const [showSearchType, setShowSearchType] = React.useState('');
    const [changeFlag, setChangeFlag] = React.useState(false);
    const [MinSalePrice, setMinSalePrice] = React.useState("");
    const [MaxSalePrice, setMaxSalePrice] = React.useState("");
    const [MinRentPrice, setMinRentPrice] = React.useState("");
    const [MaxRentPrice, setMaxRentPrice] = React.useState("");
    const [MinMortgagePrice, setMinMortgagePrice] = React.useState("");
    const [MaxMortgagePrice, setMaxMortgagePrice] = React.useState("");
    const [moreSearchDataTmp, setMoreSearchDataTmp] = React.useState({
        IsArchived: "0"
    });
    const [showSubmitDatePicker, setShowSubmitDatePicker] = React.useState(false);
    const [showMaxDatePicker, setShowMaxDatePicker] = React.useState(false);
    const [dateType, setDateType] = React.useState("");
    const [searchKey, setSearchKey] = React.useState(0);
    const [properInPlusing, setProperInPlusing] = React.useState(true);

    const positionMap = [36.32386694335946, 59.579383705135136]

    const setSalePriceBtn = useRef(null);


    const [hasMore, setHasMore] = React.useState(true);
    const [propLoading, setPropLoading] = React.useState(false);
    const [ofsset, setOfsset] = React.useState(0);
    const dataFetchedRef = useRef(false);
    const [properties, setProperties] = React.useState([]);
    const [propKey, setPropKey] = React.useState(0);

    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const locationId = useUserStore((state) => state.locationId)

    const navigation = useNavigate();
    const forceUpdate = useForceUpdate();

    const searchData = useSearchPropStore((state) => state.searchData)
    const setSearchData = useSearchPropStore((state) => state.setSearchData)
    const emptySearchData = useSearchPropStore((state) => state.emptySearchData)

    const searchType = searchData.SearchType
    const limit = searchData.Limit


    const usernameById = (item) => {
        console.log("🚀 ~ usernameById ~ Users:", Users)

        if (Users?.length) {
            let user = Users.filter(user => user.id == item)
            return user && user[0]?.username
        }
    }



    const handleClickSearchTypeModal = () => {
        setOpenSearchTypeModal(true);
    };

    const handleSearchTypeModalClose = () => {
        setOpenSearchTypeModal(false);
    };

    const handleClickOpenZoneModal = () => {
        setOpenZoneModal(true);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleZoneModalClose = () => {
        setOpenZoneModal(false);
    };

    const handleClickRentPriceModal = () => {
        setShowMeterItem(1)
        setRentPriceModal(true);
    };

    const handleSaleRentModalClose = () => {
        setRentPriceModal(false);
    };

    const handleClickRahnPriceModal = () => {
        setShowMeterItem(1)
        setRahnPriceModal(true);
    };

    const handleSaleRahnModalClose = () => {
        setRahnPriceModal(false);
    };

    const handleClickTmpRentPriceModal = () => {
        setTmpRentPriceModal(true);
    };

    const handleSaleTmpRentModalClose = () => {
        setTmpRentPriceModal(false);
    };

    const handleClickTmpRahnPriceModal = () => {
        setTmpRahnPriceModal(true);
    };

    const handleSaleTmpRahnModalClose = () => {
        setTmpRahnPriceModal(false);
    };

    const handleClickSalePriceModal = () => {
        setSalePriceModal(true);
        setShowMeterItem(1)
    };

    const handleSalePriceModalClose = () => {
        setSalePriceModal(false);
    };

    const handleClickTmpSalePriceModal = () => {
        setTmpSalePriceModal(true);
        setShowMeterItem(1)
    };

    const handleSaleTmpSalePriceModalClose = () => {
        setTmpSalePriceModal(false);
    };

    const handleClickSelectMeterModal = () => {
        setSelectMeterModal(true);
        setShowPriceItem(1)
    };

    const handleSelectMeterModalClose = () => {
        setSelectMeterModal(false);
    };

    const handleClickSelectSpaceModal = () => {
        setSelectSpaceModal(true);
        setShowPriceItem(1)
    };

    const handleSelectSpaceSpaceClose = () => {
        setSelectSpaceModal(false);
    };

    const handleClickSelectYearModal = () => {
        setSelectYearModal(true);
        setShowYearItem(1)
    };

    const handleSelectYearModalClose = () => {
        setSelectYearModal(false);
    };

    const handleClickMoreModal = () => {
        setMoreModal(true);
        var searchTmp = searchType
        emptySearchData()
        setSearchData({ name: "SearchType", value: searchTmp });
        scrollingDiv()

        setTimeout(function () { document.getElementById("floorNo-container").scroll(650, 0) }, 500)
    }
    const handleMoreModalClose = () => {
        setMoreModal(false);
    };
    const handleRemoveFilters = () => {

        emptySearchData()
        setMoreSearchDataTmp(searchData)
        setSearchKey(searchKey => searchKey + 1)
        console.log("searchData", searchData)
        setTimeout(function () { document.getElementById("floorNo-container").scroll(650, 0) }, 500)


    };



    const handleClickMelkType = () => {
        setMelkTypeModal(true);
    };

    const handleMelkTypeClose = () => {
        setMelkTypeModal(false);
    };

    const handleClickSelectTypeModal = () => {
        setOpenSelectTypeModal(true);
    };

    const handleSelectTypeModalClose = () => {
        setOpenSelectTypeModal(false);
    };

    const handleTabChange = (event, newValue) => {
        console.log("newValue", newValue)
        setTabValue(newValue);
    };

    const handleChangeMelkTabValue = (event, newValue) => {
        console.log("newValue", newValue)
        setMelkTabValue(newValue);
    };

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleClickOpenSanadModal = () => {
        setOpenSanadModal(true);
    };
    const handleCloseSanadModal = () => {
        setOpenSanadModal(false);
    };

    const handleClickOpenDateTypeModal = () => {
        setOpenDateTypeModal(true);
    };
    const handleCloseDateTypeModal = () => {
        setOpenDateTypeModal(false);
    };

    const handleClickOpenUserTypeModal = () => {
        setOpenUserTypeModal(true);
    };

    const handleCloseOpenUserTypeModal = () => {
        setOpenUserTypeModal(false);
    };


    const handleClickOpenMapModal = () => {
        console.log("map")
        setOpenMapModal(true);
    };
    const handleCloseMapModal = () => {
        setOpenMapModal(false);
    };

    const handleSetDateType = (e) => {
        console.log("handleSetDateType e.target.value", e.target.value)
        setDateType(e.target.value)
        if (e.target.value != "بازه دلخواه") {
            let tmpDate = new Date(moment())
            const tmp = { ...moreSearchDataTmp }
            if (e.target.value == "یک هفته اخیر")
                tmpDate = new Date(moment().subtract('days', 7))
            if (e.target.value == "پانزده روز اخیر")
                tmpDate = new Date(moment().subtract('days', 15))
            if (e.target.value == "یک ماه اخیر")
                tmpDate = new Date(moment().subtract('days', 30))
            if (e.target.value == "هفته جاری")
                tmpDate = new Date(moment().startOf('week').local('fa'))
            if (e.target.value == "ماه جاری")
                tmpDate = new Date(moment().startOf('jMonth').local('fa'))

            console.log("handleSetDateType date", +tmpDate.getTime())

            tmp["MinRegisterDate"] = +tmpDate.getTime()
            setMoreSearchDataTmp(tmp)
            handleCloseDateTypeModal()
        } else {
            console.log("moreSearchDataTmp['MinRegisterDate']", moreSearchDataTmp["MinRegisterDate"])
            var d = new Date(moment())

            const tmpState = { ...moreSearchDataTmp }
            tmpState["MinRegisterDate"] = d.getTime()

            setMoreSearchDataTmp(tmpState)
        }
    };

    const handleSetMinRegisterDate = (selectedDate) => {
        
        handleSetMoreSearchDataTmp("MinRegisterDate", +selectedDate.date, false, false, false)
        const tmp = { ...searchByLabelList }        
    }

    const disHandleSetDateType = (e) => {
        setDateType("")
    };

    useEffect(() => {
        const date = new Date()
        const fullDate = `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`
        const format = "YYYY"
        let object = { fullDate, format }
        const now = new DateObject(object).convert(persian, persian_en).format()
        setNowDate(now)
        for (let i = parseInt(now); i >= parseInt(now) - 51; i--) {

            const tmp = yearDates
            tmp.push(i)
            setYearDates(tmp)
        }





        // console.log("date", moment().format('YYYY-M-D'))

    }, [])

    useEffect(() => {
        if (searchType == 'Sale')
            setShowSearchType('فروش')
        if (searchType == 'Rent')
            setShowSearchType('اجاره')
        if (searchType == 'Exchange')
            setShowSearchType('معاوضه')
        if (searchType == 'SalePreSale')
            setShowSearchType('پیش فروش')
        if (searchType == 'Associate')
            setShowSearchType('مشارکت')

        console.log("searchTypeeee", searchType)
    }, [searchType])

    const areasSearchHandle = async (e) => {

        handleToggleBackdrop()
        if (e.target.value != "") {
            if (typeZone == "1")
                getAreas(true, e.target.value, "/areas/list")
            if (typeZone == "2")
                getAreas(true, e.target.value, "/webapp/divar_areas/list")
        } else {
            if (typeZone == "1")
                getAreas(true, "", "/areas/list")
            if (typeZone == "2")
                getAreas(true, "", "/webapp/divar_areas/list")
        }
    }

    const setSearchTypeHandle = (typeName, typeValue) => {
        console.log(typeName, typeValue)
        const newState = { name: typeName, value: typeValue }
        setChangeFlag(true)
        console.log("newState", newState)
        setSearchData(newState);
        setOpenSearchTypeModal(false)
    }

    const handleSetSalePrice = (isEpty = false, MaxSalePricePram = null) => {
        isEpty && emptySearchData()
        setSearchData({ name: "MinRentPrice", value: "" });
        setSearchData({ name: "MaxRentPrice", value: "" });
        setSearchData({ name: "MinMortgagePrice", value: "" });
        setSearchData({ name: "MaxMortgagePrice", value: "" });

        console.log("min max", MinSalePrice, MaxSalePrice)

        setSearchData({ name: "MinSalePrice", value: MinSalePrice });
        setChangeFlag(true)
        setSearchData({ name: "MaxSalePrice", value: MaxSalePricePram != null ? MaxSalePricePram : MaxSalePrice });
        handleSalePriceModalClose()
    }

    const handleRentPrice = (isEpty = false) => {
        console.log("rent")
        // isEpty && emptySearchData()

        setSearchData({ name: "MinMortgagePrice", value: "" });
        setSearchData({ name: "MaxMortgagePrice", value: "" });
        setSearchData({ name: "MinSalePrice", value: "" });
        setSearchData({ name: "MaxSalePrice", value: "" });


        setSearchData({ name: "MinRentPrice", value: MinRentPrice });
        setChangeFlag(true)
        setSearchData({ name: "MaxRentPrice", value: MaxRentPrice });
        handleSaleRentModalClose()
    }

    const handleRahnPrice = () => {
        setSearchData({ name: "MinRentPrice", value: "" });
        setSearchData({ name: "MaxRentPrice", value: "" });
        setSearchData({ name: "MinSalePrice", value: "" });
        setSearchData({ name: "MaxSalePrice", value: "" });


        setSearchData({ name: "MinMortgagePrice", value: MinMortgagePrice });
        setChangeFlag(true)
        setSearchData({ name: "MaxMortgagePrice", value: MaxMortgagePrice });
        handleSaleRahnModalClose()
    }

    const [areasSearch, setAreasSearch] = React.useState([]);


    const PropertyAreaHandle = (e) => {
        // emptySearchData()
        // setChangeFlag(true)
        const tmp = [...areasSearch]
        tmp.push(e.target.value)
        setAreasSearch(tmp)
    }


    const handleSetPropertyArea = () => {
        setChangeFlag(true)
        setSearchData({ name: "Areas", value: areasSearch });
        handleZoneModalClose()
    }



    useEffect(() => {
        if (changeFlag) {
            getProperties(true)
            console.log('run use efect')
        }
        console.log("useEffect searchData", searchData)
    }, [searchData])


    const getProperties = (resetState = false) => {

        // console.log("searchDataaaa", searchData)
        if (resetState) {
            setProperties([])
            console.log("reset", properties)
            setPropKey(propKey => propKey++)
            setOfsset(0);
            setHasMore(true)
        }

        setPropLoading(true)
        var searchItems = {}
        for (const item in searchData) {
            if (searchData[item] != "") {
                searchItems[item] = searchData[item]
            }
        }
        searchItems["Offset"] = ofsset
        console.log("LocationIdddddd")
        if (locationId)
            searchItems["LocationId"] = locationId

        searchItems["LandLordInfo"] = true
        searchItems["SortOrder"] = "DESC"
        searchItems["AgencyId"] = [Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id]


        console.log("searchItems", searchItems)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/properties/get/list/by/filter",
                method: "POST",
                data: searchItems,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("propres", res.data.result.Properties);

                const tmpProp = [...properties]
                if (res.data.result.Properties.length > 0) {
                    if (!resetState) {
                        res.data.result.Properties.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setProperties(tmpProp)
                        console.log("resetState not")
                    }
                    else
                        setProperties(res.data.result.Properties)

                    console.log("proper", properties)

                    setPropKey(propKey => propKey++)
                } else {
                    console.log("End")
                    setHasMore(false)
                    if (resetState) setProperties([])

                }
                setPropLoading(false)
                setChangeFlag(false)
                setTimeout(function () { setProperInPlusing(true) }, 1000)
                setTimeout(function () {
                    Array.from(document.querySelectorAll(".dash-property-item")).forEach(
                        (ele) => {
                            console.log("ele", ele)
                            ele.addEventListener("contextmenu", (e) => { e.preventDefault() });
                        })
                }, 1000)
            });

        } catch (e) {
            console.error(e);
            setPropLoading(false)
            setChangeFlag(false)
        }


    }

    // const onScroll = () => {
    //     if (document.getElementById("dashboard-content")) {
    //         const scrollTop = document.getElementById("dashboard-content").scrollTop
    //         const scrollHeight = document.getElementById("dashboard-content").scrollHeight
    //         const clientHeight = document.getElementById("dashboard-content").clientHeight

    //         if (scrollTop + clientHeight >= scrollHeight && properInPlusing) {
    //             setProperInPlusing(false)

    //             setOfsset(ofsset => ofsset + limit);
    //             // setSearchData({"name":"Offset","value":ofsset})
    //             console.log("limit", limit)
    //             console.log("ofsset", ofsset)
    //         }
    //     }
    // }

    // useEffect(() => {
    //     setTimeout(function () {
    //         if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && properties.length > 0) {
    //             document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
    //             return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
    //         }
    //     }, 500)
    // }, [properties])

    const handlePlusPropOffset = (inView) =>{
        console.log("🚀 ~ handlePlusPropOffset ~ inView:", inView)
    
            if (inView && !propLoading && hasMore) {
                setOfsset(ofsset => ofsset + limit);
            }
        } 

    useEffect(() => {
        console.log("offset use")

        if (hasMore && properties.length) {
            getProperties()
        }
    }, [ofsset])

    useEffect(() => {
        console.log("first use")
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        // emptySearchData()

        getProperties()

        getAreas()

        // const tmp = { ...moreSearchDataTmp }
        // tmp["MinRegisterDate"] = +(new Date)
        // setMoreSearchDataTmp(tmp)
    }, [])

    const handleSetDate = (selectedDate) => {
        // let object = { date, format }

        // var dateSelected = new DateObject(object).convert(persian, persian_en).format()

        // var miladiDate = moment(dateSelected, 'jYYYY/jM/jD').format('YYYY-M-D')
        // console.log(miladiDate)
        // var d = new Date(miladiDate)

        const tmp = { ...moreSearchDataTmp }
        tmp["MinRegisterDate"] = +selectedDate.date
        setMoreSearchDataTmp(tmp)
    }

    const handleSetMaxDate = (selectedDate) => {


        const tmp = { ...moreSearchDataTmp }
        tmp["MaxRegisterDate"] = +selectedDate.date
        setMoreSearchDataTmp(tmp)
    }

    const handleSetMoreSearchDataTmp = (searchItem, value, isArray = false, isAppend = false, isToggle = false, closeFunc = () => { }) => {
        const tmp = { ...moreSearchDataTmp }
        console.log("searchItem", searchItem)

        if (isAppend) {
            !tmp[searchItem] ? tmp[searchItem] = [] : null
            if (tmp[searchItem].includes(value)) {
                const index = tmp[searchItem].indexOf(value);
                const newItem = tmp[searchItem].filter((item, index) => item != value);
                console.log("newItem", newItem)
                tmp[searchItem] = newItem
            } else {
                tmp[searchItem].push(value)
            }

        } else {
            if (!isArray) {
                if (!isToggle)
                    tmp[searchItem] = value
                else {
                    if (tmp[searchItem].includes(value)) {
                        const index = tmp[searchItem].indexOf(value);
                        const newItem = tmp[searchItem].filter((item, index) => item != value);
                        console.log("newItem", newItem)
                        tmp[searchItem] = newItem
                    } else {
                        tmp[searchItem] = [value]
                    }
                }
            }
            else tmp[searchItem] = [value]
        }

        setMoreSearchDataTmp(tmp)
        closeFunc()
        console.log("moreSearchDataTmp", moreSearchDataTmp)

    }



    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    const handlBooleanMoreSearchDataTemp = (searchItem, value) => {
        const tmp = { ...moreSearchDataTmp }

        if (tmp[searchItem] == "1") {
            tmp[searchItem] = "0"
            console.log("exits")
        }
        else {
            tmp[searchItem] = "1"
            console.log("not exits", searchItem)
        }
        setMoreSearchDataTmp(tmp)

        console.log("moreSearchDataTmp", moreSearchDataTmp)

    }

    const handleSearchMore = () => {
        for (var item in moreSearchDataTmp) {
            console.log(Object.keys(moreSearchDataTmp).indexOf(item), Object.keys(moreSearchDataTmp).length)
            if (Object.keys(moreSearchDataTmp).length - 2 == Object.keys(moreSearchDataTmp).indexOf(item)) {
                setChangeFlag(true)
                setSearchData({ name: item, value: moreSearchDataTmp[item] });
            }
            else {
                setSearchData({ name: item, value: moreSearchDataTmp[item] });
            }
        }
        setOfsset(0)
        handleMoreModalClose()
    }


    //Areas Pagination

    const [areaOfsset, setAreaOfsset] = React.useState(0);
    const [hasMoreOffset, setHasMoreOffset] = React.useState(true);
    const [areasLoading, setAreasLoading] = React.useState(true);
    const [areaInPlusing, setAreaInPlusing] = React.useState(true);
    const [openTypeZone, setOpenTypeZone] = React.useState(false);


    const [typeZone, setTypeZone] = React.useState(1);
    const areaOnScroll = () => {
        if (document.getElementById("areas-container")) {
            const scrollTop = document.getElementById("areas-container").scrollTop
            const scrollHeight = document.getElementById("areas-container").scrollHeight
            const clientHeight = document.getElementById("areas-container").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && areaInPlusing) {
                setAreaInPlusing(false)
                setAreaOfsset(areaOfsset => areaOfsset + 40);

                // setSearchData({"name":"Offset","value":ofsset})
                console.log("areaOfsset", areaOfsset)
            }
        }
    }

    const handleOpenTypeZoneClose = () => {
        setOpenTypeZone(false);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };

    const handleClickTypeZone = () => {
        setOpenTypeZone(true);
    };

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    }, [areasItems])

    useEffect(() => {
        console.log("offset use")

        if (hasMoreOffset && areasItems.length) {
            getAreas()
        }
    }, [areaOfsset])



    const getAreas = (resetState = false, name = "", url = "/areas/list") => {
        if (resetState) {
            setAreasItems([])
            setAreaOfsset(0);
            setHasMoreOffset(true)
        }

        setAreasLoading(true)


        const data = {
            "LocationId": Cookies.get('locationId'),

            "AgencyId": JSON.parse(Cookies.get('agency')).Id,
            "Offset": areaOfsset,
            "Limit": 40
        }

        console.log("data", data)

        if (name != "") data["Name"] = name

        try {
            http({
                // url of the api endpoint (can be changed)
                url: url,
                method: "POST",
                data: data,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                const tempAreas = [...areasItems]
                if (res.data.result.items.length > 0) {
                    if (!resetState) {
                        res.data.result.items.map((item, index) => {
                            tempAreas.push(item)
                        })
                        setAreasItems(tempAreas)
                        console.log("resetState not")
                    }
                    else
                        setAreasItems(res.data.result.items)

                    console.log("areasItems", areasItems)


                } else {
                    console.log("End")
                    setHasMoreOffset(false)
                    if (resetState) setAreasItems([])

                }
                setTimeout(function () { setAreaInPlusing(true) }, 1000)
                setAreasLoading(false)


            });
        } catch (e) {
            console.error(e);
            setAreasLoading(false)
        }
    }


    useEffect(() => {
        console.log("typeZone", typeZone)
        if (typeZone == "1")
            getAreas(true, "", "/areas/list")
        if (typeZone == "2")
            getAreas(true, "", "/webapp/divar_areas/list")


    }, [typeZone])


    useEffect(() => {
        console.log("moreSearchDataTmp", moreSearchDataTmp)

    }, [moreSearchDataTmp])


    ///////////////////////

    const handleDeletedProps = (id) => {
        let tmpProperties = [...properties]
        // console.log("tmpProperties",tmpProperties,properties)
        tmpProperties = tmpProperties.filter(item => item.Id != id)
        setProperties(tmpProperties)
    }
    const [openCodeMelk, setOpenCodeMelk] = React.useState(false);
    const [searchRow, setSearchRow] = React.useState("");

    const handleClickOpenOpenCodeMelk = () => {
        setOpenCodeMelk(true);
    };
    const handleCodeMelkClose = () => {
        setOpenCodeMelk(false);
    };

    const handleSearchByRow = async () => {
        console.log("searchRow", searchRow)
        handleCodeMelkClose()
        setPropLoading(true)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/properties/get/list/by/filter",
                method: "POST",
                data: {
                    "Row": searchRow,
                    "AgencyId": userInfo.Id,
                    "LocationId": locationId
                }
            }).then((res) => {
                console.log("propres", res.data.result.Properties);


                if (res.data.result.Properties.length > 0) {

                    setProperties(res.data.result.Properties)

                    console.log("proper", properties)

                    setPropKey(propKey => propKey++)
                } else {

                    setProperties([])
                }
                setPropLoading(false)
            });

        } catch (e) {
            console.error(e);
            setPropLoading(false)
        }
    }


    const handleEmptyArea = () => {
        setChangeFlag(true)
        setSearchData({ name: "Areas", value: [] });
        setAreasSearch([])

    }

    const handleEmptySalePrice = () => {
        setSearchData({ name: "MaxSalePrice", value: "" });
        setChangeFlag(true)
        setSearchData({ name: "MinSalePrice", value: "" });
    }
    const handleEmptyRentPrice = () => {
        setSearchData({ name: "MinRentPrice", value: "" });
        setChangeFlag(true)
        setSearchData({ name: "MaxRentPrice", value: "" });
    }
    const handleEmptyMortgagePrice = () => {
        setSearchData({ name: "MinMortgagePrice", value: "" });
        setChangeFlag(true)
        setSearchData({ name: "MaxMortgagePrice", value: "" });
    }

    const handelEmptySearchRow = () => {
        setSearchRow("")
        getProperties(true)
    }

    const CheckMoreSearch = () => {
        if (searchData.MinRegisterDate != "" || searchData.UsageTypes != "" || searchData.CertificateTypes != "" || searchData.SearchType != "Sale"
            || searchData.PropertyTypes != "" || searchData.MaxMortgagePrice != "" || searchData.MinMortgagePrice != ""
            || searchData.MaxRentPrice != "" || searchData.MinRentPrice != "" || searchData.MaxInfrastructure != "" || searchData.MinInfrastructure != ""
            || searchData.MaxSpace != "" || searchData.MinSpace != "" || searchData.MaxPropertyAgeYear != "" || searchData.MinPropertyAgeYear != "" || searchData.StoreyNo != ""
            || searchData.Parking != "" || searchData.Elevator != "" || searchData.Store != "" || searchData.MaxStoreyCount != "" || searchData.UsageTypes != ""
            || searchData.IsArchived == "1") {
            console.log("CheckMoreSearch false", searchData)
            return true
        }


        return false

    }

    const handelEmptyMoreSearch = () => {
        setChangeFlag(true)
        emptySearchData()

    }


    ///////////////////////////////////////User Modal
    const [openUsersModal, setOpenUsersModal] = React.useState(false)
    const [labelsChecked, setLabelsChecked] = React.useState({})

    const [Users, setUsers] = React.useState([]);
    const [UserOffset, setUserOffset] = React.useState(0);
    const [HasMoreUsers, setHasMoreUsers] = React.useState(true);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [inPlusingUser, setinPlusingUser] = React.useState(true);


    const getUsers = (resetState = false) => {
        if (resetState) {
            setUsers([])
            console.log("reset", Users)
            setPropKey(propKey => propKey++)
            setUserOffset(0);
            setHasMoreUsers(true)
        }

        setUsersLoading(true)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/users/get-my-users",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("users", res);

                const tmpProp = [...Users]
                if (res.data.result.Users.length > 0) {
                    if (!resetState) {
                        res.data.result.Users.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setUsers(tmpProp)

                        setPropKey(propKey => propKey++)
                    }
                    else
                        setUsers(res.data.result.Users)


                    setPropKey(propKey => propKey++)

                } else {
                    console.log("End")
                    setHasMoreUsers(false)
                    if (resetState) setUsers([])

                }

                console.log("users ff", Users)
                setUsersLoading(false)
                setTimeout(function () { setinPlusingUser(true) }, 1000)
            });

        } catch (e) {
            console.error(e);
            setUsersLoading(false)

        }


    }


    const onUsersScroll = () => {
        if (document.getElementById("users-content")) {

            const scrollTop = document.getElementById("users-content").scrollTop
            const scrollHeight = document.getElementById("users-content").scrollHeight
            const clientHeight = document.getElementById("users-content").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && inPlusingUser) {
                setUserOffset(UserOffset => UserOffset + 1);
                // setSearchData({"name":"Offset","value":UserOffset})
                console.log("UserOffset", UserOffset)
                setinPlusingUser(false)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)


    }, [Users])

    useEffect(() => {
        console.log("offset use")

        if (HasMoreUsers && Users.length) {
            getUsers()
        }
    }, [UserOffset])


    const handleClickOpenUsersModal = () => {


        getUsers(true)
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)
        setOpenUsersModal(true);
    };

    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };


    const handleSetUsers = (user) => {
        handleSetMoreSearchDataTmp("Users", user?.id, false, true)
    }

    const left = <Button className='rounded-50' sx={{ bgcolor: '#E7E7E7!important', color: '#8F8F8F', display: 'flex', gap: '5px' }} onClick={handleClickOpenMapModal}>
        <MapMarkerIcon />
        نقشه
        <ArrowRightIcon className='rotate-180-minus' />
    </Button>

    return (
        <>
            <PageLayout title='جستجو ملک' key={propKey}
                leftHeaderItem={left}
            >
                <Box id="dashboard-content" sx={{ pt: 2 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs example"
                        className='tab-nav'
                        dir="rtl"

                    >
                        <Tab label={showSearchType} className='tab-nav-item' onClick={handleClickSearchTypeModal} />
                        <Button className={`tab-nav-item ${searchData.Areas.length && 'tab-active'}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                            <Box onClick={handleClickOpenZoneModal}>
                                محدوده
                            </Box>
                            {searchData.Areas.length ? <IconButton onClick={handleEmptyArea} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}
                        </Button>

                        {
                            searchType == "Sale" ?
                                <Button className={`tab-nav-item ${searchData.MaxSalePrice != "" || searchData.MinSalePrice != "" ? 'tab-active' : ""}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                                    <Box onClick={handleClickSalePriceModal}>
                                        مبلغ خرید
                                    </Box>
                                    {searchData.MaxSalePrice != "" || searchData.MinSalePrice != "" ? <IconButton onClick={handleEmptySalePrice} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}
                                </Button>
                                : ''
                        }
                        {
                            searchType == "Rent" ?
                                <Button className={`tab-nav-item ${searchData.MinRentPrice != "" || searchData.MaxRentPrice != "" ? 'tab-active' : ""}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                                    <Box onClick={handleClickRentPriceModal}>
                                        مبلغ اجاره
                                    </Box>
                                    {searchData.MinRentPrice != "" || searchData.MaxRentPrice != "" ? <IconButton onClick={handleEmptyRentPrice} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}
                                </Button>
                                : ''
                        }
                        {
                            searchType == "Rent" ?
                                <Button className={`tab-nav-item ${searchData.MinMortgagePrice != "" || searchData.MaxMortgagePrice != "" ? 'tab-active' : ""}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                                    <Box onClick={handleClickRahnPriceModal}>
                                        مبلغ رهن
                                    </Box>
                                    {searchData.MinMortgagePrice != "" || searchData.MaxMortgagePrice != "" ? <IconButton onClick={handleEmptyMortgagePrice} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}
                                </Button>
                                : ''
                        }
                        {/* <Button className={`tab-nav-item ${searchRow != "" && 'tab-active'}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                            <Box onClick={handleClickOpenOpenCodeMelk}>
                                کد ملک
                            </Box>
                            {searchRow != "" ? <IconButton onClick={handelEmptySearchRow} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}
                        </Button> */}

                        <Button className={`tab-nav-item ${CheckMoreSearch() && 'tab-active'}`} sx={{ display: "felx", alignItems: "center", gap: "10px", px: 2, minWidth: "unset!important" }}>
                            <Box onClick={handleClickMoreModal}>
                                بیشتر
                            </Box>
                            {CheckMoreSearch() ? <IconButton onClick={handelEmptyMoreSearch} sx={{ p: 0 }}><CloseIcon width='10px' /></IconButton> : ""}
                        </Button>
                    </Tabs>
                    <Box sx={{ px: 3, py: 1 }} >
                        {
                            properties && properties.length > 0 ?
                                properties.map((item, index) => (
                                    <PropItem key={index} propInfo={item} handleDeletedProps={handleDeletedProps} />
                                ))
                                : !propLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                        }
                        {
                            propLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                        }
                        <InView
                        as='div'
                        onChange={(inView, entry) =>
                            handlePlusPropOffset(inView, entry)
                        }></InView>
                    </Box>
                </Box>
                <ButtonNavigation />

            </PageLayout>

            {openZoneModal && <Dialog className="dialog-box"
                fullScreen
                open={openZoneModal}
                onClose={handleZoneModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        <IconButton autoFocus color="inherit" onClick={handleClickTypeZone}>
                            <SettingIcon />
                        </IconButton>
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            انتخاب محدوده
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleZoneModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 120px)!important", overflow: 'auto' }} id="areas-container" >
                    <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                        <InputBase placeholder='محدوده یا محله مورد نظر خود را وارد کنید' className='flex-1' onChange={areasSearchHandle} />
                        <IconButton>
                            <SreachIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        <Grid container spacing={3}>

                            {
                                areasItems && areasItems.length > 0 ?
                                    areasItems.map((item, index) => (
                                        <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                            <input type="checkbox" name='propertyType' value={item.Name} id={`PropertyArea${index}`} className="d-none typeCheck" onChange={PropertyAreaHandle} />
                                            <label htmlFor={`PropertyArea${index}`} className='typeLabel w-100'>
                                                <span className="flex-1">{item.Name}</span>
                                            </label>
                                        </Grid>
                                    ))
                                    : !areasLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                areasLoading ? <Box sx={{ textAlign: 'center', width: "100%", p: 2 }}>درحال بارگیری...</Box> : ""

                            }
                        </Grid>
                    </Box>
                </Box>
                <Button
                    onClick={handleSetPropertyArea}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {openTypeZone && <Dialog className="dialog-box"
                fullScreen
                open={openTypeZone}
                onClose={handleOpenTypeZoneClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        {/* <IconButton>
                            <SettingIcon />
                        </IconButton> */}
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>

                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenTypeZoneClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }}>
                    <Box>
                        <input type="radio" name='propType' id="myOptions" className="d-none typeCheck" checked={typeZone == "1"} value="موارد خودم" onChange={() => setTypeZone("1")} />
                        <label htmlFor="myOptions" className='typeLabel w-auto justify-content-right gap-10'>
                            <PersonList />
                            موارد خودم
                        </label>
                    </Box>
                    <Box>
                        <input type="radio" name='propType' id="daryafti" className="d-none typeCheck" checked={typeZone == "2"} value="موارد دریافتی از پایش" onChange={() => setTypeZone("2")} />
                        <label htmlFor="daryafti" className='typeLabel w-auto justify-content-right gap-10'>
                            <DownloadIcon />
                            موارد دریافتی از پایش
                        </label>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleOpenTypeZoneClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>جستجو</Button>
            </Dialog>}

            {tmpSalePriceModal && <Dialog className="dialog-box"
                fullScreen
                open={tmpSalePriceModal}
                onClose={handleSaleTmpSalePriceModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSaleTmpSalePriceModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onChange={(e) => {
                                    handleSetMoreSearchDataTmp("MinSalePrice", e.target.value)
                                }}
                                value={moreSearchDataTmp.MinSalePrice}
                                onFocus={() => setShowMeterItem(1)}
                            />
                            {
                                showMeterItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MinSalePrice", item.value)
                                                        setShowMeterItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowMeterItem(2)}
                                value={moreSearchDataTmp.MaxSalePrice}
                                onChange={(e) => {
                                    handleSetMoreSearchDataTmp("MaxSalePrice", e.target.value)
                                }}
                            />
                            {
                                showMeterItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MaxSalePrice", item.value)
                                                        handleSaleTmpSalePriceModalClose()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSaleTmpSalePriceModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {rentPriceModal && <Dialog className="dialog-box"
                fullScreen
                open={rentPriceModal}
                onClose={handleSaleRentModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSaleRentModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onChange={(e) => setMinRentPrice(e.target.value)}
                                value={MinRentPrice}
                                onFocus={() => setShowMeterItem(1)}
                            />
                            {
                                showMeterItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => {
                                                        setMinRentPrice(item.value)
                                                        setShowMeterItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                value={MaxRentPrice}
                                onFocus={() => setShowMeterItem(2)}
                                onChange={(e) => setMaxRentPrice(e.target.value)}
                            />
                            {
                                showMeterItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => {
                                                        setMaxRentPrice(item.value)
                                                        handleRentPrice()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleRentPrice}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {rahnPriceModal && <Dialog className="dialog-box"
                fullScreen
                open={rahnPriceModal}
                onClose={handleSaleRahnModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSaleRahnModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                value={MinMortgagePrice}
                                onChange={(e) => setMinMortgagePrice(e.target.value)}
                                onFocus={() => setShowMeterItem(1)}
                            />
                            {
                                showMeterItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => {
                                                        setMinMortgagePrice(item.value)
                                                        setShowMeterItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowMeterItem(2)}
                                value={MaxMortgagePrice}
                                onChange={(e) => setMaxMortgagePrice(e.target.value)}
                            />
                            {
                                showMeterItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => {
                                                        setMaxMortgagePrice(item.value)
                                                        handleRahnPrice()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleRahnPrice}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {tmpRentPriceModal && <Dialog className="dialog-box"
                fullScreen
                open={tmpRentPriceModal}
                onClose={handleSaleTmpRentModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSaleTmpRentModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onChange={(e) => handleSetMoreSearchDataTmp("MinRentPrice", e.target.value)}
                                onFocus={() => setShowMeterItem(1)}
                            />
                            {
                                showMeterItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => handleSetMoreSearchDataTmp("MinRentPrice", item.value)} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowMeterItem(2)}
                                onChange={(e) => handleSetMoreSearchDataTmp("MaxRentPrice", e.target.value)}
                            />
                            {
                                showMeterItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => handleSetMoreSearchDataTmp("MaxRentPrice", item.value)} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSaleTmpRentModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {tmpRahnPriceModal && <Dialog className="dialog-box"
                fullScreen
                open={tmpRahnPriceModal}
                onClose={handleSaleTmpRahnModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSaleTmpRahnModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onChange={(e) => handleSetMoreSearchDataTmp("MinMortgagePrice", e.target.value)}
                                onFocus={() => setShowMeterItem(1)}
                            />
                            {
                                showMeterItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => handleSetMoreSearchDataTmp("MinMortgagePrice", item.value)} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowMeterItem(2)}
                                onChange={(e) => handleSetMoreSearchDataTmp("MaxMortgagePrice", e.target.value)}
                            />
                            {
                                showMeterItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => handleSetMoreSearchDataTmp("MaxMortgagePrice", item.value)} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSaleTmpRahnModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}


            {salePriceModal && <Dialog className="dialog-box"
                fullScreen
                open={salePriceModal}
                onClose={handleSalePriceModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSalePriceModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                value={MinSalePrice}
                                onChange={(e) => setMinSalePrice(e.target.value)}
                                onFocus={() => setShowMeterItem(1)}

                            />
                            {
                                showMeterItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minPrice" id={`min-${index}`} className="d-none" onChange={() => {
                                                        setMinSalePrice(item.value)
                                                        setShowMeterItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                value={MaxSalePrice}
                                onFocus={() => setShowMeterItem(2)}
                                onChange={(e) => setMaxSalePrice(e.target.value)}
                            />
                            {
                                showMeterItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            priceItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxPrice" id={`max-${index}`} className="d-none" onChange={() => {
                                                        setMaxSalePrice(item.value)
                                                        handleSetSalePrice(false, item.value)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item.title}
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={() => handleSetSalePrice(false)}
                    ref={setSalePriceBtn}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {moreModal && <Dialog className="dialog-box"
                fullScreen
                open={moreModal}
                onClose={handleMoreModalClose}
                TransitionComponent={Transition}

            >
                <Box key={searchKey}>
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666', width: '100%', position: 'fixed', top: '0px' }}>
                        <Toolbar sx={{ bgcolor: '#fff' }}>
                            <Button sx={{ bgcolor: '#8F8F8F!important', fontSize: '11px', color: '#fff' }} className="rounded-50" onClick={handleRemoveFilters}>
                                حذف فیلتر ها
                            </Button>
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب محدوده */}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleMoreModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', mt: 2, paddingBottom: '80px', px: 2 }} key={searchKey}>

                        <Box sx={{ width: '100%' }}>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickOpenDateTypeModal}>
                                <span>
                                    {dateType == "" ? "تعیین تاریخ" : dateType}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        {dateType == "بازه دلخواه" && <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>از تاریخ</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <div className='flex-1 w-chile-100'>
                                    {/* <DatePicker calendar={persian} placeholder="تعیین تاریخ"
                                        locale={persian_fa} onChange={handleSetDate}  value={new Date()} /> */}
                                    <InputBase value={formatJalali(moreSearchDataTmp["MinRegisterDate"])} className='flex-1' onClick={() => setShowSubmitDatePicker(true)} />
                                    <Picker
                                        isOpen={showSubmitDatePicker}
                                        config={config}
                                        value={moreSearchDataTmp["MinRegisterDate"]}
                                        initialValue={new Date(moreSearchDataTmp["MinRegisterDate"] ? new Date(moreSearchDataTmp["MinRegisterDate"]) : new Date())}
                                        minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                        maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                        onSubmit={handleSetMinRegisterDate}
                                        // onChange={handleSetDate}
                                        onClose={() => setShowSubmitDatePicker(false)}
                                        highlightWeekends
                                    />
                                </div>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>}
                        {dateType == "بازه دلخواه" && <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>تا تاریخ</label>

                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <div className='flex-1 w-chile-100'>
                                    {/* <DatePicker calendar={persian} placeholder="تعیین تاریخ"
                                        locale={persian_fa} onChange={handleSetDate}  value={new Date()} /> */}
                                    <InputBase value={formatJalali(moreSearchDataTmp["MaxRegisterDate"])} className='flex-1' onClick={() => setShowMaxDatePicker(true)} />
                                    <Picker
                                        isOpen={showMaxDatePicker}
                                        config={config}
                                        initialValue={new Date(moreSearchDataTmp["MaxRegisterDate"] ? new Date(moreSearchDataTmp["MaxRegisterDate"]) : new Date())}
                                        minDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 1, day: 1 })}
                                        maxDate={newDate({ year: parseInt(moment().format("jYYYY")) + 10, month: 12, day: 29 })}
                                        onSubmit={handleSetMaxDate}
                                        // onChange={handleSetMaxDate}
                                        onClose={() => setShowMaxDatePicker(false)}
                                        highlightWeekends
                                    />
                                </div>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>}

                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>نوع معامله</label>
                            <Box className="inputs-container" onClick={handleClickSelectTypeModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <Box>
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "Sale" ? "فروش" : ""}
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "Rent" ? "رهن" : ""}
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "Exchange" ? "معاوضه" : ""}
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "SalePreSale" ? "پیش فروش" : ""}
                                    {moreSearchDataTmp && moreSearchDataTmp.SearchType && moreSearchDataTmp.SearchType == "Associate" ? "مشارکت" : ""}
                                </Box>

                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>نوع ملک</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickMelkType}>
                                <span>


                                    {moreSearchDataTmp.PropertyTypes && moreSearchDataTmp.PropertyTypes.length ? moreSearchDataTmp.PropertyTypes.map((item, index) => {
                                        return <span key={index}>{item} {index != moreSearchDataTmp.PropertyTypes.length - 1 && "،"} </span>
                                    }) : ""}

                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        {/* <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>کاربر ثبت کننده</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickOpenUsersModal}>
                                <span>
                                    {moreSearchDataTmp?.Users?.length ? moreSearchDataTmp.Users.map((item, index) => {
                                        return <span key={index}>{usernameById(item)} {index != moreSearchDataTmp.Users.length - 1 && "،"} </span>
                                    }) : ""}

                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box> */}
                        {CheckPermissions(userInfo, "search_properties_by_user") ? <SearchByUser moreSearchDataTmp={moreSearchDataTmp} setMoreSearchDataTmp={setMoreSearchDataTmp} handleSetMoreSearchDataTmp={handleSetMoreSearchDataTmp} /> : null}
                        {
                            searchType == "Sale" ?
                                <Box sx={{ width: '100%' }} key={searchKey}>
                                    <label htmlFor='meter' className='f-16 text-label'>مبلغ خرید <span className='text-gray'>(تومان)</span></label>
                                    <Box className="inputs-container" onClick={handleClickTmpSalePriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>
                                            {moreSearchDataTmp.MinSalePrice ? moreSearchDataTmp.MinSalePrice : ""}
                                            {moreSearchDataTmp.MinSalePrice && moreSearchDataTmp.MaxSalePrice ? " , " : ""}
                                            {moreSearchDataTmp.MaxSalePrice ? moreSearchDataTmp.MaxSalePrice : ""}
                                        </span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box> : null}
                        {
                            searchType == "Rent" ?
                                <Box sx={{ width: '100%' }}>
                                    <label htmlFor='meter' className='f-16 text-label'>مبلغ اجاره <span className='text-gray'>(تومان)</span></label>
                                    <Box className="inputs-container" onClick={handleClickTmpRentPriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>
                                            {moreSearchDataTmp.MinRentPrice ? parseInt(moreSearchDataTmp.MinRentPrice).toLocaleString() : ""}
                                            {moreSearchDataTmp.MinRentPrice && moreSearchDataTmp.MaxRentPrice ? " , " : ""}
                                            {moreSearchDataTmp.MaxRentPrice ? parseInt(moreSearchDataTmp.MaxRentPrice).toLocaleString() : ""}
                                        </span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box> : null}
                        {
                            searchType == "Rent" ?
                                <Box sx={{ width: '100%' }}>
                                    <label htmlFor='meter' className='f-16 text-label'>مبلغ رهن <span className='text-gray'>(تومان)</span></label>
                                    <Box className="inputs-container" onClick={handleClickTmpRahnPriceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                        <span>
                                            {moreSearchDataTmp.MinMortgagePrice ? parseInt(moreSearchDataTmp.MinMortgagePrice).toLocaleString() : ""}
                                            {moreSearchDataTmp.MinMortgagePrice && moreSearchDataTmp.MaxMortgagePrice ? " , " : ""}
                                            {moreSearchDataTmp.MaxMortgagePrice ? parseInt(moreSearchDataTmp.MaxMortgagePrice).toLocaleString() : ""}
                                        </span>
                                        <ArrowRightIcon className='rotate-180-minus' />
                                    </Box>
                                </Box> : null}
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>زیربنا <span className='text-gray'>(متر)</span></label>
                            <Box className="inputs-container" onClick={handleClickSelectMeterModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>
                                    {moreSearchDataTmp.MinInfrastructure ? moreSearchDataTmp.MinInfrastructure : ""}
                                    {moreSearchDataTmp.MinInfrastructure && moreSearchDataTmp.MaxInfrastructure ? " , " : ""}
                                    {moreSearchDataTmp.MaxInfrastructure ? moreSearchDataTmp.MaxInfrastructure : ""}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>متراژ زمین <span className='text-gray'>(متر)</span></label>
                            <Box className="inputs-container" onClick={handleClickSelectSpaceModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>
                                    {moreSearchDataTmp.MinSpace ? moreSearchDataTmp.MinSpace : ""}
                                    {moreSearchDataTmp.MinSpace && moreSearchDataTmp.MaxSpace ? " , " : ""}
                                    {moreSearchDataTmp.MaxSpace ? moreSearchDataTmp.MaxSpace : ""}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>

                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>سال ساخت</label>
                            <Box className="inputs-container" onClick={handleClickSelectYearModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>
                                    {moreSearchDataTmp.MinPropertyAgeYear ? moreSearchDataTmp.MinPropertyAgeYear : ""}
                                    {moreSearchDataTmp.MinPropertyAgeYear && moreSearchDataTmp.MaxPropertyAgeYear ? " , " : ""}
                                    {moreSearchDataTmp.MaxPropertyAgeYear ? moreSearchDataTmp.MaxPropertyAgeYear : ""}
                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label className='f-16 text-label'>طبقه</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                                <Box className="numbers-scroll" id="floorNo-container" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>
                                    {
                                        Array.apply(0, Array(51)).map(function (x, i) {
                                            return <Box key={i}>
                                                <input type="checkbox" name='floor' id={`floor${i - 25}`} value={i - 25} checked={moreSearchDataTmp.StoreyNo && moreSearchDataTmp.StoreyNo.includes((i - 25).toString())} onChange={e => handleSetMoreSearchDataTmp("StoreyNo", e.target.value, true, true)} className="d-none NumberCheck" />
                                                <label htmlFor={`floor${i - 25}`} className='NumberLabel'>
                                                    {i - 25 == 0 ? <span style={{ fontSize: "10px" }}>همکف</span> : i - 25}
                                                </label>
                                            </Box>
                                        })
                                    }
                                </Box>
                            </Box>
                        </Box>
                        {/* <Box sx={{ width: '100%' }}>
                            <label className='f-16 text-label'>طبقه</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', direction: 'ltr', justifyContent: 'space-around', textAlign: 'center' }}>
                                {
                                    Array.apply(0, Array(10)).map(function (x, i) {
                                        return <Box key={i}>
                                            <input type="radio" name='floor' id={`floor${i - 2}`} value={i - 2} className="d-none NumberCheck" onChange={e => handleSetMoreSearchDataTmp("StoreyNo", e.target.value)} />
                                            <label htmlFor={`floor${i - 2}`} className='NumberLabel'>
                                                {i - 2}
                                            </label>
                                        </Box>
                                    })
                                }
                            </Box>
                        </Box> */}
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>نوع سند</label>
                            <Box className="inputs-container" onClick={handleClickOpenSanadModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>

                                    {moreSearchDataTmp.CertificateTypes && moreSearchDataTmp.CertificateTypes.length ? moreSearchDataTmp.CertificateTypes.map((item, index) => {
                                        return <span key={index}>{item} {index != moreSearchDataTmp.CertificateTypes.length - 1 && "،"} </span>
                                    }) : ""}

                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label htmlFor='meter' className='f-16 text-label'>نوع کاربری</label>
                            <Box className="inputs-container" onClick={handleClickOpenUserTypeModal} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                <span>

                                    {moreSearchDataTmp.UsageTypes && moreSearchDataTmp.UsageTypes.length ? moreSearchDataTmp.UsageTypes.map((item, index) => {
                                        return <span key={index}>{item} {index != moreSearchDataTmp.UsageTypes.length - 1 && "،"} </span>
                                    }) : ""}

                                </span>
                                <ArrowRightIcon className='rotate-180-minus' />
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%' }}>
                            <label className='f-16 text-label'>تعداد اتاق ها</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1, overflow: "hidden" }}>
                                <Box className="numbers-scroll" sx={{ width: '100%', display: 'flex', direction: 'ltr', justifyContent: 'start', textAlign: 'center', overflow: "auto" }}>

                                    {
                                        Array.apply(0, Array(51)).map(function (x, i) {
                                            return <Box key={i}>
                                                <input type="checkbox" name='room' id={`room${i}`} value={i} checked={moreSearchDataTmp.MaxStoreyCount && moreSearchDataTmp.MaxStoreyCount.includes(i.toString())} onChange={e => handleSetMoreSearchDataTmp("MaxStoreyCount", e.target.value, true, true)} className="d-none NumberCheck" />
                                                <label htmlFor={`room${i}`} className='NumberLabel'>
                                                    {i}
                                                </label>
                                            </Box>
                                        })
                                    }
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <label className='f-16'>ویژگی های اصلی</label>
                            <Grid container spacing={1} sx={{ mt: 1 }}>

                                <Grid item xs={4}>

                                    <input type="checkbox" id="major1" className="d-none typeCheck" value="انباری" name='major' onChange={(e) => handlBooleanMoreSearchDataTemp("Store", e.target.value)} />
                                    <label htmlFor="major1" className='typeLabel w-auto'>
                                        <span className='flex-1'>انباری</span>
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type="checkbox" id="major2" className="d-none typeCheck" value="آسانسور" name='major' onChange={(e) => handlBooleanMoreSearchDataTemp("Elevator", e.target.value)} />
                                    <label htmlFor="major2" className='typeLabel w-auto'>
                                        <span className='flex-1'>آسانسور</span>
                                    </label>
                                </Grid>
                                <Grid item xs={4}>
                                    <input type="checkbox" id="major3" className="d-none typeCheck" value="پارکینگ" name='major' onChange={(e) => handlBooleanMoreSearchDataTemp("Parking", e.target.value)} />
                                    <label htmlFor="major3" className='typeLabel w-auto'>
                                        <span className='flex-1'>پارکینگ</span>
                                    </label>

                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography>موارد بایگانی شده</Typography>
                            <Switch checked={moreSearchDataTmp["IsArchived"] == "1" ? true : false} onChange={e => handlBooleanMoreSearchDataTemp("IsArchived", e.target.value)} />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography>موارد موارد دریافتی از پایش</Typography>
                            <Switch />
                        </Box>
                        <Box>

                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }}>
                                <InputBase id='meter' placeholder='جستجو در توضیحات یا آدرس' onChange={e => handleSetMoreSearchDataTmp("SearchKeys", e.target.value, true)} />
                            </Box>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleSearchMore}
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>مشاهده نتایج</Button>
                </Box>
            </Dialog>}

            {melkTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={melkTypeModal}
                onClose={handleMelkTypeClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>
                        {/* <Button autoFocus color="inherit">
                            حذف فیلتر ها
                        </Button> */}
                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleMelkTypeClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                    </Toolbar>
                </AppBar>

                <Box className='tab-container' sx={{ px: 2 }}>
                    <Box>
                        <Tabs value={melkTabValue} onChange={handleChangeMelkTabValue} className="inputs-container" sx={{ width: 'auto', p: 0, display: 'flex' }} aria-label="basic tabs example">
                            <Tab icon={<CityIcon />} sx={{ flex: 1 }} iconPosition="start" label="شهری" {...a11yProps(0)} />
                            <Tab icon={<SettingIcon />} sx={{ flex: 1 }} iconPosition="start" label="صنعتی و کشاورزی" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={melkTabValue} index={0}>
                        <Grid container spacing={5} className='gap-top-20' sx={{ pt: 2 }}>
                            {data.propertyType.cities.map((city, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }} key={index}>
                                    <input type="checkbox" name='propertyType' value={city} id={`item${index}`} className="d-none typeCheck" checked={moreSearchDataTmp.PropertyTypes && moreSearchDataTmp.PropertyTypes != "" && moreSearchDataTmp.PropertyTypes.includes(city)} onChange={(e) => handleSetMoreSearchDataTmp("PropertyTypes", e.target.value, true, true, true)} />
                                    <label htmlFor={`item${index}`} className='typeLabel w-100'>
                                        <span className="flex-1">{city}</span>
                                    </label>
                                </Grid>
                            ))}
                            {/* {data.propertyType.map((melkItem, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="checkbox" id={`item${index}`} className="d-none typeCheck" />
                                        <label htmlFor={`item${index}`} className='typeLabel'>
                                            {melkItem}
                                        </label>
                                    </Grid>
                                ))} */}

                        </Grid>
                    </TabPanel>
                    <TabPanel value={melkTabValue} index={1}>
                        <Grid container spacing={5} className='gap-top-20' sx={{ pt: 2 }}>
                            {data.propertyType.industrial.map((industry, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="checkbox" name='propertyType' value={industry} id={`item${index}`} className="d-none typeCheck" checked={moreSearchDataTmp.PropertyTypes && moreSearchDataTmp.PropertyTypes != "" && moreSearchDataTmp.PropertyTypes.includes(industry)} onChange={(e) => handleSetMoreSearchDataTmp("PropertyTypes", e.target.value, true, true, true)} />
                                    <label htmlFor={`item${index}`} className='typeLabel w-100'>
                                        <span className="flex-1">{industry}</span>
                                    </label>
                                </Grid>
                            ))}
                        </Grid>
                    </TabPanel>
                </Box>
                <Button
                    onClick={handleMelkTypeClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {openSelectTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={openSelectTypeModal}
                onClose={handleSelectTypeModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب کنید */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectTypeModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>
                    <Button className="inputs-container border-0"
                        sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#E8E5FE!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "Sale", false, false, false, handleSelectTypeModalClose)}
                    >
                        <Box className="flex-1" sx={{ color: '#707070' }}>فروش</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FAF3C0!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "Rent", false, false, false, handleSelectTypeModalClose)}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>رهن و اجاره</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FFCAA1!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "Exchange", false, false, false, handleSelectTypeModalClose)}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>معاوضه</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#D6ECD2!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "SalePreSale", false, false, false, handleSelectTypeModalClose)}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>پیش خرید</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#BDECF3!important', py: 1, px: 2 }} onClick={(e) => handleSetMoreSearchDataTmp("SearchType", "Associate", false, false, false, handleSelectTypeModalClose)}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>مشارکت</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                </Box>
                {/* <Button
                    onClick={handleSelectTypeModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
            </Dialog>}

            {selectMeterModal && <Dialog className="dialog-box"
                fullScreen
                open={selectMeterModal}
                onClose={handleSelectMeterModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectMeterModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowPriceItem(1)}
                                value={moreSearchDataTmp.MinInfrastructure}
                                onChange={(e) => handleSetMoreSearchDataTmp("MinInfrastructure", e.target.value)}
                            />
                            {
                                showPriceItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            meterItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minMeter" id={`min-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MinInfrastructure", item)
                                                        setShowPriceItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item} متر
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                onFocus={() => setShowPriceItem(2)}
                                value={moreSearchDataTmp.MaxInfrastructure}
                                onChange={(e) => handleSetMoreSearchDataTmp("MaxInfrastructure", e.target.value)}
                            />
                            {
                                showPriceItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            meterItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxMeter" id={`max-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MaxInfrastructure", item)
                                                        handleSelectMeterModalClose()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item} متر
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSelectMeterModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {selectSpaceModal && <Dialog className="dialog-box"
                fullScreen
                open={selectSpaceModal}
                onClose={handleSelectSpaceSpaceClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectSpaceSpaceClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                value={moreSearchDataTmp.MinSpace}
                                onFocus={() => setShowPriceItem(1)}
                                onChange={(e) => handleSetMoreSearchDataTmp("MinSpace", e.target.value)}
                            />
                            {
                                showPriceItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            meterItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minMeter" id={`min-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MinSpace", item)
                                                        setShowPriceItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`min-${index}`} className='w-100 d-block'>
                                                            {item} متر
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'
                                InputProps={{
                                    inputComponent: NumericFormatCustom,
                                }}
                                variant="standard"
                                value={moreSearchDataTmp.MaxSpace}
                                onFocus={() => setShowPriceItem(2)}
                                onChange={(e) => handleSetMoreSearchDataTmp("MaxSpace", e.target.value)}
                            />
                            {
                                showPriceItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            meterItems.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxMeter" id={`max-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MaxSpace", item)
                                                        handleSelectSpaceSpaceClose()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`max-${index}`} className='w-100 d-block'>
                                                            {item} متر
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSelectSpaceSpaceClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>
            }

            {selectYearModal && <Dialog className="dialog-box"
                fullScreen
                open={selectYearModal}
                onClose={handleSelectYearModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">

                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSelectYearModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleZoneModalClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box>
                    <Grid container spacing={2} sx={{ px: 2 }}>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداقل'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'

                                variant="standard"
                                onFocus={() => setShowYearItem(1)}
                                value={moreSearchDataTmp.MinPropertyAgeYear}
                                onChange={(e) => handleSetMoreSearchDataTmp("MinPropertyAgeYear", e.target.value)}
                            />
                            {
                                showYearItem == 1 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            yearDates.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="minYear" id={`year-min-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MinPropertyAgeYear", item)
                                                        setShowYearItem(2)
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`year-min-${index}`} className='w-100 d-block'>
                                                            {item} ({parseInt(nowDate) - parseInt(item)} سال)
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label=""
                                placeholder='حداکثر'
                                name="sale-price"
                                pattern="(\d)+"
                                id="formatted-numberformat-input"
                                className='remove-underline dir-ltr text-input-1 w-100'

                                variant="standard"
                                onFocus={() => setShowYearItem(2)}
                                value={moreSearchDataTmp.MaxPropertyAgeYear}
                                onChange={(e) => handleSetMoreSearchDataTmp("MaxPropertyAgeYear", e.target.value)}
                            />
                            {
                                showYearItem == 2 ?
                                    <Box sx={{ mt: 2 }}>
                                        {
                                            yearDates.map((item, index) => {
                                                return <Box className="price-item" key={index}>
                                                    <input type="radio" name="maxYear" id={`year-max-${index}`} className="d-none" onChange={() => {
                                                        handleSetMoreSearchDataTmp("MaxPropertyAgeYear", item)
                                                        handleSelectYearModalClose()
                                                    }} />
                                                    <Button className='w-100 d-block' sx={{ textAlign: 'right' }}>
                                                        <label htmlFor={`year-max-${index}`} className='w-100 d-block'>
                                                            {item} ({parseInt(nowDate) - parseInt(item)} سال)
                                                        </label>
                                                    </Button>
                                                </Box>
                                            })
                                        }
                                    </Box>
                                    : ''
                            }
                        </Grid>
                    </Grid>
                </Box>
                <Button
                    onClick={handleSelectYearModalClose}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {openDateTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={openDateTypeModal}
                onClose={handleCloseDateTypeModal}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            انتخاب کنید
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseDateTypeModal}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>

                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        {dateTypes.map((item, index) => (
                            <Box sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                <input type="radio" id={`sanad${index}`} className="d-none typeCheck" checked={dateType != "" && dateType == item.value} value={item.value} onChange={handleSetDateType} onClick={disHandleSetDateType} />
                                <label htmlFor={`sanad${index}`} className='typeLabel check-has-arrow'>
                                    {item.title}
                                </label>
                            </Box>
                        ))}
                    </Box>
                </Box>
                {/* <Button
                    onClick={handleCloseDateTypeModal}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button> */}
            </Dialog>}

            {openSanadModal && <Dialog className="dialog-box"
                fullScreen
                open={openSanadModal}
                onClose={handleCloseSanadModal}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            انتخاب کنید
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseSanadModal}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                    <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center" }}>
                        <InputBase placeholder='' className='flex-1' />
                        <IconButton>
                            <SreachIcon />
                        </IconButton>
                    </Box>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                        <Grid container spacing={4}>
                            {data.typeDoc.map((doc, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="checkbox" id={`sanad${index}`} className="d-none typeCheck" value={doc} checked={moreSearchDataTmp.CertificateTypes && moreSearchDataTmp.CertificateTypes.includes(doc)} onChange={e => handleSetMoreSearchDataTmp("CertificateTypes", e.target.value, false, true)} />
                                    <label htmlFor={`sanad${index}`} className='typeLabel'>
                                        {doc}
                                    </label>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
                <Button
                    onClick={handleCloseSanadModal}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {openUserTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={openUserTypeModal}
                onClose={handleCloseOpenUserTypeModal}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            نوع کاربری
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseOpenUserTypeModal}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px' }}>
                    <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
                        <Grid container spacing={5} sx={{ pt: 2 }} className='gap-top-20'>
                            {data.AccountType.map((AccountTypeKey, index) => (
                                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index} >
                                    <input type="checkbox" id={`AccountType${index}`} value={AccountTypeKey} className="d-none typeCheck" checked={moreSearchDataTmp.UsageTypes && moreSearchDataTmp.UsageTypes.includes(AccountTypeKey)} onChange={e => handleSetMoreSearchDataTmp("UsageTypes", e.target.value, false, true)} />
                                    <label htmlFor={`AccountType${index}`} className='typeLabel'>
                                        {AccountTypeKey}
                                    </label>
                                </Grid>
                            ))}

                        </Grid>
                    </Box>
                </Box>
                <Button
                    onClick={handleCloseOpenUserTypeModal}
                    className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {openSearchTypeModal && <Dialog className="dialog-box"
                fullScreen
                open={openSearchTypeModal}
                onClose={handleSearchTypeModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب کنید */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSearchTypeModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>
                    <Button className="inputs-container border-0"
                        sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#E8E5FE!important', py: 1, px: 2 }}
                        onClick={() => {
                            setSearchTypeHandle('SearchType', 'Sale')
                        }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>فروش</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setSearchTypeHandle('SearchType', 'Rent')
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FAF3C0!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>رهن و اجاره</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setSearchTypeHandle('SearchType', 'Exchange')
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#FFCAA1!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>معاوضه</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setSearchTypeHandle('SearchType', 'SalePreSale')
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#D6ECD2!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>پیش خرید</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                    <Button className="inputs-container border-0" onClick={() => {
                        setSearchTypeHandle('SearchType', 'Associate')
                    }} sx={{ width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#BDECF3!important', py: 1, px: 2 }}>
                        <Box className="flex-1" sx={{ color: '#707070' }}>مشارکت</Box>
                        <ArrowRightIcon className='rotate-180-minus' />
                    </Button>
                </Box>
            </Dialog>}

            {openMapModal && <MapComponent  openMapModal={openMapModal} handleCloseMapModal={handleCloseMapModal} />}

            {openCodeMelk && <Dialog className="dialog-box"
                fullScreen
                open={openCodeMelk}
                onClose={handleCodeMelkClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            {/* انتخاب محدوده */}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCodeMelkClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                    <Box>
                        <Box className="inputs-container" sx={{ width: 'auto' }}>
                            <InputBase id='meter' value={searchRow} onChange={(e) => setSearchRow(e.target.value)} placeholder='کد ملک مورد نظر خود را وارد کنید' />
                        </Box>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleSearchByRow} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
            </Dialog>}

            {openUsersModal && <Dialog className="dialog-box"
                fullScreen
                open={openUsersModal}
                onClose={handleOpenUsersModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            کاربران
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenUsersModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 140px)!important", overflow: "auto" }} id="uset-content">
                    <Box >
                        <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }}>
                            {
                                Users && Users.length > 0 ?
                                    Users.map((item, index) => (

                                        <Button className={`inputs-container has-arrow ${moreSearchDataTmp?.Users?.includes(item?.id) ? 'checked' : ""}`} sx={{ display: "flex", justifyContent: "space-between", width: "100%", p: 1 }} onClick={() => handleSetUsers(item)} key={index}>
                                            <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>

                                                <Typography component="span">{item?.username}</Typography>
                                            </Box>
                                            {/* <IconButton>
                                                <PenIcon2 />
                                            </IconButton> */}
                                        </Button>

                                    ))
                                    : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                            }

                        </Box>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleOpenUsersModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button>
            </Dialog>}
        </>
    );
}

export default SearchProperty;